<template>
  <!-- 厕所组建 -->
  <div class="Others18Charts">
    <div class="item0 item" :style="{ 'font-size': titleFontSize + 'px', ...getScale() }">
      {{ Configuration.propertyData.titleText.value }}
    </div>
    <div class="item1 item">
      <div class="one-left" :style="getScale()">
        <div :style="getWidthStyle(-4, '#43dcdd')">总蹲位数：</div>
        <div :style="getWidthStyle(-4, '#fff', true)">{{ toilet.total }}</div>
      </div>
      <div class="one-right" :style="getScale()">
        <div :style="getWidthStyle(-4, '#feff17')">使用数：</div>
        <div :style="getWidthStyle(-4, '#feff17', true)">{{ toilet.use }}</div>
      </div>
    </div>
    <div class="item-pit">
      <div class="tp-text">
        <div :style="getWidthStyle(-4, '#fff')">总数</div>
        <div :style="getWidthStyle(-4, '#fff')">占用</div>
      </div>
      <div :style="getScale()" class="pit-box" v-show="toilet.pitLocation">
        <div class="pit-sex" v-for="(item, index) in toilet.pitLocation" :key="item.sectionType">
          <div :style="getWidthStyle(-4, '#43dcdd')">{{ item.sectionName }}</div>
          <div :style="getWidthStyle(-4, '#fff')">{{ item.latrineCnt }}</div>
          <div :style="getWidthStyle(-4, '#fff')">{{ item.latrineBuysCnt }}</div>
        </div>
      </div>
    </div>
    <div class="item2 item">
      <div :style="getWidthStyle(-4, '#fff')">当日人流量 :</div>
      <div class="data" :style="getWidthStyle(-4, '#fff')">{{ toilet.today }}</div>
    </div>
    <div class="item3 item">
      <div class="three-left">
        <div :style="getWidthStyle(-2, '#feff17', true)">环境数据</div>
      </div>
      <div class="three-right" :style="getScale()">
        <div class="three-r-top">
          <div>
            <img src="../../../assets/img/toilet/temperature.png" alt="" />
            <span :style="getWidthStyle(-8, '#43dcdd')" class="three-text">温度：</span>
            <span>{{ toilet.temperature }}℃</span>
          </div>
          <div>
            <img src="../../../assets/img/toilet/humidity.png" alt="" />
            <span :style="getWidthStyle(-8, '#43dcdd')" class="three-text">湿度：</span>
            <span>{{ toilet.humidity }}%</span>
          </div>
        </div>
        <div class="three-r-middle">
          <div>
            <img src="../../../assets/img/toilet/pm2.5.png" alt="" />
            <span :style="getWidthStyle(-8, '#43dcdd')" class="three-text">pm2.5：</span>
            <span>{{ toilet.pm25 }}μm</span>
          </div>
        </div>
        <div></div>
        <div class="three-r-bottom">
          <div>
            <img src="../../../assets/img/toilet/NH3.png" alt="" />
            <span :style="getWidthStyle(-8, '#43dcdd')" class="three-text">氨气：</span>
            <span>{{ toilet.ammonia }}</span>
          </div>
          <div>
            <img src="../../../assets/img/toilet/H2S.png" alt="" />
            <span :style="getWidthStyle(-8, '#43dcdd')" class="three-text">硫化氢：</span>
            <span>{{ toilet.sulfuretted }}%</span>
          </div>
        </div>
      </div>
    </div>
    <div class="item4 item" :style="getScale()">
      <div class="four-left" :style="getScale()">
        <img src="../../../assets/img/toilet/electric.png" alt="" />
        <div>
          <p :style="getWidthStyle(-4, '#fff')">当前用电</p>
          <p :style="getWidthStyle(-4, '#feff17', true)">{{ toilet.currentElectricity }}</p>
        </div>
      </div>
      <div class="four-right" :style="getScale()">
        <img src="../../../assets/img/toilet/water.png" alt="" />
        <div>
          <p :style="getWidthStyle(-4, '#fff')">当前用水</p>
          <p :style="getWidthStyle(-4, '#feff17', true)">{{ toilet.currentWater }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import * as Echarts from 'echarts';
// import {mapState} from 'vuex
import { request } from '../../../common/request';
export default {
  name: 'Others12Charts',
  components: {},
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      data: [],
      loading: true, // 加载对象
      params: {}, // 请求参数
      paramsCopy: {},
      fontStyle: {},
      sex: '1',

      // 卫生间
      toilet: {
        total: '0', // 总蹲位数
        use: '0', // 使用数
        today: '0', // 当日人流量
        temperature: '0', // 温度
        humidity: '0', // 湿度
        ammonia: '0', // 氨气
        sulfuretted: '0', // 硫化氢
        currentElectricity: 0, // 当日用电
        currentWater: 0, // 当日用水
        pitLocation: [
          { sectionName: '男卫', latrineCnt: 0, latrineBuysCnt: 0 },
          { sectionName: '女卫', latrineCnt: 0, latrineBuysCnt: 0 },
          { sectionName: '第三卫', latrineCnt: 0, latrineBuysCnt: 0 },
        ],
      },
      format: percentage => (percentage === 100 ? 'Full' : `${percentage}%`),
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function() {
        this.getxFontSize();
        this.getyFontSize();
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
  },
  beforeMount() {},
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    // this.getApiDataResByFilterAndResponseQuery();
    // 默认取api参数
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    // console.log('aaaa',params);
    this.params = eval('(' + params + ')');
    this.paramsCopy = eval('(' + params + ')');
    // this.setStyle();
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
  },
  computed: {
    componentWidth() {
      return this.Configuration.style.width;
    },
    componentHeight() {
      return this.Configuration.style.height;
    },
    style() {
      return this.ProjectInfo.Style.componentName;
    },
    titleFontSize() {
      return this.Configuration.propertyData.fontStyle.value.titleSize;
    },
    scale() {
      let widthScale = (this.componentWidth / 393).toFixed(10);
      let heightScale = (this.componentHeight / 363).toFixed(10);
      return [widthScale, heightScale];
    },
  },
  filters: {
    dealData(data) {
      console.log(data, '-----------');
      return Number(data).toFixed(2);
    },
  },

  methods: {
    getScale() {
      return {};
    },
    getMarginTop(a) {
      return {
        marginTop: `${this.$h_Ratio(a + this.getShowfontSizeBase(), this.$store)}px`,
        // 'transform':`scale(${this.scale[0]},${this.scale[1]})`
      };
    },
    getPadding(a, b) {
      return {
        padding: `${this.$w_Ratio(a + this.getShowfontSizeBase(), this.$store)}px 
               ${this.$w_Ratio(b + this.getShowfontSizeBase(), this.$store)}px`,
      };
    },
    getStyle(e = '') {
      let style = {};
      switch (this.style) {
        case 'V1Style':
          style['V1' + e] = true;
          break;
        case 'V2Style':
          style['V2' + e] = true;
          break;
        case 'V3Style':
          style['V3' + e] = true;
          break;
        case 'V4Style':
          style['V4' + e] = true;
          break;
        case 'V5Style':
          style['V5' + e] = true;
          break;
        case 'V6Style':
          style['V6' + e] = true;
          break;
        case 'V7Style':
          style['V7' + e] = true;
          break;
        case 'V8Style':
          style['V8' + e] = true;
          break;
        default:
          break;
      }
      return style;
    },
    // 根据不同的风格取不同的颜色
    setStyle() {
      let color;
      switch (this.style) {
        case 'V1Style':
          color = '#eee';
          break;
        case 'V2Style':
          color = '#eee';
          break;
        case 'V3Style':
          color = '#7fdfff';
          break;
        case 'V4Style':
          color = '#b044f8';
          break;
        case 'V5Style':
          color = '#09af60';
          break;
        default:
          color = '#eee';
          break;
      }
      this.$refs['loading-box'].style.setProperty('--color', color); // 给变量赋值
    },
    getxFontSize() {
      return {
        'font-size': this.fontStyle.xAxisSize + 'px',
        color: this.fontStyle.xAxisColor,
      };
    },
    getyFontSize() {
      return {
        'font-size': this.fontStyle.yAxisSize + 'px',
        color: this.fontStyle.yAxisColor,
      };
    },
    getWidthStyle(fs = 14, color = '#fff', isWeight = false) {
      return {
        color,
        fontWeight: isWeight ? 'bold' : 'unset',
        whiteSpace: 'nowrap',
        // transform: `scale(${this.scale[0]},${this.scale[1]})`,
      };
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      console.log(ParamData, '484646846');
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let sex = '1'; // 0 女 ，1 男
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (ParamData && ParamData.sex) {
        sex = ParamData.sex;
        this.sex = sex;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
        this.fontStyle = fontStyle;
      }
      console.log(source, '处理后的厕所数据');
      this.toilet = tdata[0];

      // this.data = source;
      // 关闭加载
      // this.$nextTick(() => {
      //   // this.loading.close();
      //   this.loading = false;
      //   // console.log('关闭加载', this.loading.close);
      // });

      // console.log(source, 'aaaaaa');
      // console.log(seriesList);
      // console.log(chartColor);
      // console.log(fontStyle);
      // console.log(grid);

      // if (source.length == 0) {
      //   source[0] = this.toilet;
      // } else {
      //   Object.keys(source[0]).forEach(key => {
      //     if (key.lastIndexOf('_' + sex) == -1 && key != 'currentElectricity' && key != 'currentWater') {
      //       delete source[0][key];
      //     }
      //   });

      //   // for(let key in source[0]){
      //   //   if(key.lastIndexOf('_'+sex) == -1 && key.indexOf('_')!=-1){
      //   //     console.log('删除');
      //   //     delete source[0].key
      //   //   }
      //   // }
      // }

      // let total = 0;
      // source.forEach(item => {
      //   total += Number(item.y);
      // });

      // this.male = ((source[0].y / total) * 100).toFixed(2);
      // this.female = ((source[1].y / total) * 100).toFixed(2);
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);

          data.source.forEach(item => {
            item.y = 1;
          });

          this.setEchartsOptions(data);
          setTimeout(() => {
            this.setEchartsOptions(this.$_.cloneDeep(ChartsData.staticData));
          }, 0);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setTimeout(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setTimeout(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      // 清除之前的 interval 任务（如果有的话）
      if (this.apiIntervalTaskID) {
        clearInterval(this.apiIntervalTaskID);
      }
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 定义一个异步函数来处理数据请求和更新
        const fetchAndUpdateData = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
        };
        // 首次调用
        fetchAndUpdateData();
        // 设置 interval 定时任务
        this.apiIntervalTaskID = setInterval(fetchAndUpdateData, ChartsData?.apiData?.apiInterval * 1000);
        console.log('开启 interval 任务，间隔请求');
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };
          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function(data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            // console.log('getApiDataResByFilterAndResponseQuery');
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },

  Configuration: {
    componentTitle: '智慧厕所2.0',
    componentName: 'Others18Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others12Charts.png',
    id: '',
    style: {
      width: 393,
      height: 363,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgb(247 247 247 / 4%)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%22202one-0three-01%22,%22date_end%22:%22202one-0three-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果        
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            apiUrlMethod: 'get',
            isUseInterval: true,
            apiInterval: 10,
            apiUrlMethod: 'get',
            apiPostParams: '',
            isUseUserKey: true, // 是否使用user_key
          },
          staticData: {
            seriesList: ['人数'],
            source: [],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 450,
          height: 200,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 20,
          xAxisColor: 'rgba(96, 231, 255, 1)',
          yAxisSize: 20,
          yAxisColor: 'rgba(15, 237, 146, 1)',
        },
      },

      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Others18Charts {
  color: white;
  width: 100%;
  height: 100%;
  padding: 4%;
  background: url('../../../assets/img/toilet/bk.png') no-repeat;
  background-size: 100% 100%;
  .echarts {
    width: 100%;
    height: 100%;
  }
  .item {
    width: 100%;
    height: auto;
    margin-top: 8px;
    &:nth-child(1) {
      margin-top: 0;
    }
  }
  .item0 {
    // height: 8%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .item-pit {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 14px;
    background: rgba(26, 69, 81, 0.856);
    border: 1px solid #15808b;
    padding: 10px 0;
    height: 22%;
    .tp-text {
      display: flex;
      flex-direction: column;
      width: 14%;
      position: relative;
      top: 10px;
    }
    .pit-box {
      display: flex;
      justify-content: space-around;
      width: 68%;
    }
    .pit-sex {
      /* transform: scale(1, 1); */
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .pit-sex div:nth-of-type(1) {
      margin-bottom: 4px;
    }
  }

  .item1 {
    height: 10%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(26, 69, 81, 0.856);
    border: 1px solid #15808b;
    .one-left {
      width: 55%;
      display: flex;
      padding: 6px 0;
      justify-content: center;
      border-right: 1px solid #15808b;
    }
    .one-right {
      width: 45%;
      padding: 6px 0;
      display: flex;
      justify-content: center;
    }
  }
  .item2 {
    height: 10%;
    // display: flex;
    // align-items: center;
    padding: 6px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(26, 69, 81, 0.856);
    border: 1px solid #15808b;
    .data {
      margin-left: 18px;
    }
    .progress {
      margin: 0 10px;
      // width: 65%;
      flex: 1;
      :deep(.el-progress-bar__outer) {
        background: #0f8792;
        overflow: unset;
      }
      :deep(.el-progress__text) {
        color: #fff;
      }
      :deep(.el-progress-bar__innerText) {
        position: relative;
        top: -10px;
        left: 6px;
      }
    }
  }
  .item3 {
    height: 26%;
    padding: 2%;
    display: flex;
    align-items: center;
    background: rgba(26, 69, 81, 0.856);
    .three-left {
      height: 100%;
      width: 28%;
      display: flex;
      justify-content: center;
      align-items: center;
      // flex-direction: column;
      // flex-basis: 0;
      // flex: 1;
      padding: 0 33px 0 0;
      // border-right: 1px solid #15808b;
      div {
      }
    }
    .three-right {
      width: 60%;
      height: 74%;
      // flex: 1;
      padding-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // align-items: center;
      border-left: 1px solid #15808b;
      .three-r-middle {
        height: 50%;
        margin: 4px 0;
        display: flex;
        justify-content: center;
        div {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        img {
          width: 16px;
          margin-right: 6px;
        }
      }
      .three-r-top {
        /* padding-bottom: 10px; */
        display: flex;
        justify-content: space-between;
        /* border-bottom: 1px solid #15808b; */
        div {
          display: flex;
          justify-content: center;
          align-items: center;
          // margin-left: 10px;
          &:nth-child(2) {
            margin-left: 10px;
          }
          img {
            margin-right: 6px;
          }
        }
      }
      .three-r-bottom {
        /* height: 50%; */
        /* padding-top: 10px; */
        display: flex;
        justify-content: space-between;
        div {
          display: flex;
          justify-content: center;
          align-items: center;
          //  margin-left: 10px;
          &:nth-child(2) {
            margin-left: 10px;
          }
          img {
            margin-right: 6px;
          }
        }
      }
    }
  }
  .item4 {
    height: 24%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    font-size: 20px;
    .four-left,
    .four-right {
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        font-size: 18px;
        p:nth-child(1) {
          margin-bottom: 4px;
          font-size: 15px;
        }
      }
    }
  }
}
@media screen and (min-width: 3300px) {
  .Others18Charts .item-pit .pit-box {
    width: 38% !important;
    font-size: 20px !important;
  }
  .Others18Charts .item {
    font-size: 23px !important;
  }
  .Others18Charts .item-pit .tp-text {
    width: 20% !important;
    top: 12px;
    font-size: 20px !important;
  }
  .Others18Charts .item-pit .pit-sex div:nth-of-type(3) {
    padding-top: 4px !important;
    font-size: 22px !important;
  }
  .Others18Charts .item-pit .pit-sex div:nth-of-type(2) {
    padding-top: 2px !important;
    font-size: 22px !important;
  }
  .Others18Charts .item-pit .pit-sex div:nth-of-type(1) {
    font-size: 24px !important;
  }
  .Others18Charts .three-text {
    font-size: 22px !important;
    margin-right: 6px !important;
  }
  .Others18Charts .item1 .one-right {
    width: 9% !important;
    justify-content: space-around !important;
    font-size: 24px !important;
  }
  .Others18Charts .item1 {
    font-size: 20px !important;
    justify-content: space-around !important;
  }
  .Others18Charts .item1 .one-left {
    width: 12% !important;
    justify-content: space-around !important;
    border-right: none !important;
    font-size: 24px;
  }
  .Others18Charts .item2 .data {
    margin-left: 90px !important;
  }
  .Others18Charts .item3 .three-right .three-r-bottom div img {
    margin-right: 16px !important;
  }
  .Others18Charts .item3 .three-right {
    width: 60% !important;
    font-size: 26px !important;
    position: relative !important;
    left: -48px !important;
    top: -14px !important;
    border-left: none !important;
  }
  .Others18Charts .item3 {
    justify-content: space-evenly !important;
  }
  .Others18Charts .item3 .three-right .three-r-top div img {
    margin-right: 14px !important;
  }
  .Others18Charts .item3 .three-left {
    position: relative !important;
    right: 24px !important;
    border-right: 1px solid #15808b !important;
  }
  .Others18Charts .item3 .three-right .three-r-middle img {
    margin-right: 16px !important;
  }
  .Others18Charts .item4 img {
    width: 100% !important;
  }
  .Others18Charts .item4 .four-left div p:nth-child(1),
  .Others18Charts .item4 .four-right div p:nth-child(1) {
    font-size: 24px !important;
  }
  .Others18Charts .item4 .four-left,
  .Others18Charts .item4 .four-right {
    justify-content: space-evenly !important;
  }
  .Others18Charts .item4 .four-left div,
  .Others18Charts .item4 .four-right div {
    font-size: 24px !important;
  }
  .Others18Charts .item4 {
    align-items: center !important;
    width: 62% !important;
    position: relative !important;
    left: 115px !important;
  }
}
@media screen and (max-width: 1400px) {
  .Others18Charts .item4 {
    height: 13% !important;

    img {
      width: 40% !important;
    }
  }
  .Others18Charts .item4 .four-left div,
  .Others18Charts .item4 .four-right div {
    font-size: 15px !important;
  }
  .Others18Charts .item3 .three-left {
    width: 20% !important;
    padding: 0 0 0 0 !important;
  }
  .three-right {
    width: 78% !important;
    position: relative !important;
    top: -2px !important;
  }
  .Others18Charts .item3 .three-right .three-r-top div:nth-child(2) {
    margin-left: 29px !important;
  }
  .Others18Charts .item3 .three-right .three-r-bottom div:nth-child(2) {
    margin-left: 16px !important;
  }
  .Others18Charts .item4 .four-left div p:nth-child(1),
  .Others18Charts .item4 .four-right div p:nth-child(1) {
    margin-bottom: 2px !important;
    font-size: 12px;
  }
  /* .Others18Charts .item3 {
    font-size: 12px !important;
  } */
  .Others18Charts .item2,
  .Others18Charts .item3,
  .Others18Charts .item1 {
    font-size: 12px !important;
  }
  .Others18Charts .item-pit {
    font-size: 13px !important;
    margin-top: 12px !important;
  }
}
</style>
